import React from "react";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseFormPage from "../../../base/BaseFormPage";
import QueueingConfigPagePresenter from "./QueueingConfigPagePresenter";
import { dialog, printComponent } from "../../../nq-component";
import { footer, html } from "framer-motion/client";
import NavBar from "../../../components/navbar";
import DialogSuccess from "../components/DialogSuccess";
import SpeechSettings from "../components/SpeechSettings";
import { progress } from "framer-motion";

class QueueingConfigPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {
        speech_rate: 1,
        speech_pitch: 1,
        speech_volume: 1,
        repetition_count: 1,
      },
      progress: true,
    };
    this.presenter = new QueueingConfigPagePresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      findObjectUseCase()
    );
  }

  getCollectionName() {
    return "speech_config";
  }

  showSuccess(message) {
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  setObject(object) {
    this.setState({ object: object });
  }

  showProgress() {
    this.setState({ progress: true });
  }

  hideProgress() {
    this.setState({ progress: false });
  }

  applyChanges() {
    this.presenter.submit();
  }

  onChange(value, field) {
    const { object } = this.state;
    this.setState({ object: { ...object, [field]: value } });
  }

  success(message) {
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  render() {
    const user = this.getCurrentUser();
    const { object, progress } = this.state;

    console.warn("object", object);
    return (
      <>
        <NavBar user={user} />
        <div className="p-3 p-lg-4">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="fw-bold text-capitalize">Voice Settings</h1>
          </div>
          <div>
            <SpeechSettings
              setting={object}
              progress={progress}
              submit={this.applyChanges.bind(this)}
              onChange={this.onChange.bind(this)}
            />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(QueueingConfigPage);
